import { Box } from '@chakra-ui/react';
import type { McpClientProvider } from '@fluenceur/types';
import {
  SiClaude,
  SiClaudeHex,
  SiGooglegemini,
  SiGooglegeminiHex,
  SiOpenai,
} from '@icons-pack/react-simple-icons';
import { PlugTypeA } from 'iconoir-react';

const logos = {
  chatgpt: { Icon: SiOpenai, color: '#000000' },
  claude: { Icon: SiClaude, color: SiClaudeHex },
  gemini: { Icon: SiGooglegemini, color: SiGooglegeminiHex },
};

/** Provider comes from trusted server registration, never a client-supplied name or URL. */
export function McpClientLogo({ provider }: { provider?: McpClientProvider | null }) {
  const logo = provider && Object.hasOwn(logos, provider) ? logos[provider] : null;
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexShrink={0}
      boxSize={12}
      borderWidth="1px"
      borderRadius="xl"
      bg={logo ? 'white' : 'bg.subtle'}
      color="fg"
      aria-hidden="true"
    >
      {logo ? (
        <logo.Icon width={26} height={26} color={logo.color} />
      ) : (
        <PlugTypeA width={26} height={26} />
      )}
    </Box>
  );
}
